import { useQuery, QueryFunction } from 'react-query';
import { getAllJobs, GetJobsQueries, Job } from '../../services/apiSLTP/jobs';

type UseJobsQueryOptions = {
    queries?: GetJobsQueries;
};

const getJobs: QueryFunction<Job[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseJobsQueryOptions];
    const { queries } = options;

    const response = await getAllJobs(queries);
    return response.data;
};

export const useJobsQuery = (options: UseJobsQueryOptions) => {
    return useQuery(['jobs', options], getJobs);
};
